import React from 'react';

export default function ToastStack({ toasts, onDismiss }) {
    if (!toasts || toasts.length === 0) return null;

    return (
        <div style={{ position: 'fixed', top: '14px', right: '14px', zIndex: 9999, display: 'grid', gap: '8px', maxWidth: '360px' }}>
            {toasts.map((t) => (
                <div
                    key={t.id}
                    style={{
                        borderRadius: '10px',
                        padding: '10px 12px',
                        border: `1px solid ${colorByType(t.type).border}`,
                        background: colorByType(t.type).bg,
                        color: colorByType(t.type).text,
                        boxShadow: '0 8px 20px rgba(0,0,0,0.08)',
                        display: 'flex',
                        justifyContent: 'space-between',
                        gap: '8px',
                        alignItems: 'center'
                    }}
                >
                    <div style={{ fontSize: '13px' }}>{t.message}</div>
                    <button
                        type="button"
                        onClick={() => onDismiss(t.id)}
                        style={{ border: 'none', background: 'transparent', cursor: 'pointer', color: colorByType(t.type).text, fontWeight: 700 }}
                    >
                        ×
                    </button>
                </div>
            ))}
        </div>
    );
}

function colorByType(type) {
    if (type === 'success') return { bg: '#ecfdf5', border: '#a7f3d0', text: '#065f46' };
    if (type === 'warning') return { bg: '#fffbeb', border: '#fde68a', text: '#92400e' };
    if (type === 'error') return { bg: '#fef2f2', border: '#fecaca', text: '#991b1b' };
    return { bg: '#eff6ff', border: '#bfdbfe', text: '#1e40af' };
}
